var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('p',{staticClass:"mb-0"},[_c('b',[_vm._v(_vm._s(_vm.name || 'Qualifications'))])]),_vm._v(" "),_vm._l(((_vm.value || [])),function(ref){
var name = ref.name;
var date = ref.date;
return _c('p',{key:name,staticStyle:{"line-height":"1.2rem"}},[_c('span',[_vm._v(_vm._s(name))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatDate(date, 'MMM YYYY')))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1435253c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/QualificationsShow.vue
// module id = Md8q
// module chunks = 0 106